import React from 'react';
import '../App.css';
import './blogpost.css';
import SEO from '../SEO';
import IntroVideo from '../images/purple_sparkles.mp4';
import VideoComponent from './VideoComponent.js';
import { useParams, useNavigate } from 'react-router-dom';
import { useScrollBehavior } from './useScrollBehavior.js';
import Footer from './footer.js';
import blogPosts from './blogData.js';

const BlogArticle = () => {

  useScrollBehavior();



  const { slug } = useParams();
  const navigate = useNavigate();

  const post = blogPosts.find((item) => item.slug === slug);

  const title = post
  ? `${post.title} | Yokai Software`
  : "Article Not Found | Yokai Software";

const description = post
  ? post.description
  : "The requested blog article could not be found.";

const canonical = post
  ? `https://yokaisoftware.com/blog/${post.slug}`
  : "https://yokaisoftware.com/blog";

const image = "https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png";

const schema = post
  ? {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://yokaisoftware.com/#organization",
          name: "Yokai Software",
          url: "https://yokaisoftware.com/",
          logo: "https://yokaisoftware.com/apple-touch-icon(1)_crow_logo.png",
        },
        {
          "@type": "BlogPosting",
          "@id": `https://yokaisoftware.com/blog/${post.slug}#article`,
          headline: post.title,
          description: post.description,
          url: `https://yokaisoftware.com/blog/${post.slug}`,
          datePublished: post.date,
          author: {
            "@type": "Organization",
            name: "Yokai Software",
          },
          publisher: {
            "@id": "https://yokaisoftware.com/#organization",
          },
          mainEntityOfPage: {
            "@id": `https://yokaisoftware.com/blog/${post.slug}#webpage`,
          },
          image: image,
        },
        {
          "@type": "WebPage",
          "@id": `https://yokaisoftware.com/blog/${post.slug}#webpage`,
          url: `https://yokaisoftware.com/blog/${post.slug}`,
          name: `${post.title} | Yokai Software`,
          description: post.description,
          isPartOf: {
            "@id": "https://yokaisoftware.com/#website",
          },
        },
      ],
    }
  : {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "Article Not Found | Yokai Software",
      url: "https://yokaisoftware.com/blog",
      description: "The requested blog article could not be found.",
    };

  if (!post) {
    return (
      <>
        <SEO
          title={title}
          description={description}
          canonical={canonical}
          image={image}
          schema={schema}
        />
        <div id="blog_article_page">
          <div id="blog_article_not_found">
            <h1>Article Not Found</h1>
            <button
              type="button"
              onClick={() => {
                navigate('/blog');
                window.scrollTo(0, 0);
              }}
            >
              Back to Blog
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
    <SEO
      title={title}
      description={description}
      canonical={canonical}
      image={image}
      schema={schema}
    />
    
     <VideoComponent  videoSrc={IntroVideo} />
      <div id="blog_article_page">
        <div id="blog_article_hero">
          <div id="blog_article_hero_inner">
            <div id="blog_article_category">{post.category}</div>
            <h1>{post.title}</h1>
            <p id="blog_article_date">{post.date}</p>
            <p id="blog_article_description">{post.description}</p>
          </div>
        </div>

        <div id="blog_article_body_wrap">
          <div id="blog_article_body">
            {post.content.map((block, index) => {
              if (block.type === 'heading') {
                return <h2 key={index}>{block.text}</h2>;
              }

              return <p key={index}>{block.text}</p>;
            })}
          </div>

          <div id="blog_article_button_row">
            <button
              type="button"
              onClick={() => {
                navigate('/blog');
                window.scrollTo(0, 0);
              }}
            >
              Back to Blog
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BlogArticle;